// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:959px){.k-booking-review__submit[data-v-b4e1c772]{display:flex!important}}", ""]);
// Exports
module.exports = exports;
